import { Checkbox } from '@material-ui/core';
import { Field } from 'formik';
import React from 'react';

export default function OverMedianCheckbox({ value }: any) {
  return (
    <Field name="over_median">
      {({ field, form }: any) => (
        <Checkbox
          checked={field.value.includes(value)}
          value={value}
          onChange={() => {
            if (field.value.includes(value)) {
              const nextValue = field.value.filter((v: any) => v !== value);
              form.setFieldValue('over_median', nextValue);
            } else {
              const nextValue = field.value.concat(value);
              form.setFieldValue('over_median', nextValue);
            }
          }}
        />
      )}
    </Field>
  );
}
